import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageRoomSessionDetailsResponse } from '@/models'

interface UseGetPackageRoomSessionDetailsParams {
  sessionId?: number
}

export const PACKAGE_SESSION_DETAILS_BASE_QUERY_KEY = 'useGetPackageRoomSessionDetails'

export const getPackageRoomSessionDetails = async (
  sessionId: number,
  signal?: AbortSignal,
): Promise<PackageRoomSessionDetailsResponse> => {
  const response = await authAPI.get<PackageRoomSessionDetailsResponse>(
    `/package-room/session/${sessionId}`,
    { signal },
  )
  return response.data
}

export const useGetPackageRoomSessionDetails = (params: UseGetPackageRoomSessionDetailsParams) => {
  const { sessionId } = params

  return useQuery({
    enabled: !!sessionId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getPackageRoomSessionDetails(sessionId!, signal),
    queryKey: [PACKAGE_SESSION_DETAILS_BASE_QUERY_KEY, sessionId],
  })
}
